// 更新步骤状态
export const UPDATE_STEP_STATUS = 'UPDATE_STEP_STATUS'

// 更新提交信息
export const UPDATE_SUBMIT_INFO = 'UPDATE_SUBMIT_INFO'

// 更新当前活动步骤
export const UPDATE_ACTIVE = 'UPDATE_ACTIVE'

// 更新步骤完成情况
export const UPDATE_STEP_COMPLETE = 'UPDATE_STEP_COMPLETE'

// 设置步骤信息
export const SET_STEP_INFO = 'SET_STEP_INFO'
